import React, { useEffect, useMemo, useState } from 'react';
import {
  Table,
  Input,
  Select,
  Button,
  Image,
  Space,
  Form,
  Modal,
  message,
  Switch,
} from 'antd';
import type { ColumnsType } from 'antd/es/table';
import { useNavigate } from 'react-router-dom';
import dayjs from 'dayjs';
import { PageLink } from '@/config/pageConfig';
import { deleteArtworkAiFilterStyleByStyleId, getAllArtworkAiFilterStyle, getArtworkAiFilterStylePage, updateArtworkAiFilterStyle } from '@/api/filter';
import { useRequest } from 'ahooks';
import { ArtworkAifilterStyleDTO } from '@/types/filter';

const { Option } = Select;

const pageSize = 10;

const ConvertList: React.FC = () => {
  const [form] = Form.useForm();
  const navigate = useNavigate();
  // const [styleTypeOptions, setStyleTypeOptions] = useState<string[]>([]);

  // useEffect(() => {
  //   fetchStyleTypes();
  // }, []);

  // const fetchStyleTypes = async () => {
  //   const { data } = await getAllArtworkAiFilterStyle();
  //   setStyleTypeOptions(
  //     data.data.map((item) => item.styleType || '').filter(Boolean)
  //   );
  // };

  const {
    data: styleTypeOptions = [],
  } = useRequest(
    async () => {
      const resp = await getAllArtworkAiFilterStyle();
      if (resp.status !== 200) {
        return [];
      }
      return resp.data.data;
    }
  );

  const {
    data,
    loading,
    refresh: refetch,
    run
  } = useRequest(
    async (currentPage = 1) => {
      const formParams = form.getFieldsValue();
      if (formParams.createTime) {
        formParams.createTimeStart = dayjs(formParams.createTime[0])
          .startOf('day')
          .valueOf();
        formParams.createTimeEnd = dayjs(formParams.createTime[1])
          .endOf('day')
          .valueOf();

        delete formParams.createTime;
      }

      const params = {
        ...formParams,
        pageNum: currentPage,
        pageSize
      };
      const resp = await getArtworkAiFilterStylePage(params);
      if (resp.status !== 200) {
        return {
          total: 0,
          currentPage: 0,
          pageSize: 0,
          records: [],
        };
      }
      return resp.data.data;
    }
  );

  const page = useMemo(() => {
    return data?.current ?? 1
  }, [data]);


  const onSearch = () => {
    run();
  };

  const onReset = () => {
    form.resetFields();
    run();
  }

  const onEdit = (record: ArtworkAifilterStyleDTO) => {
    navigate(`${PageLink.Convert}/edit/${record.styleId}`);
  };

  const onDelete = (styleId?: number) => {
    if (!styleId) return;
    Modal.confirm({
      title: '确定删除该风格？',
      content: '删除后将无法恢复',
      okText: '确认',
      cancelText: '取消',
      onOk: async () => {
        try {
          const res = await deleteArtworkAiFilterStyleByStyleId({
            styleId
          });
          if (res.data.success) {
            message.success('删除成功');
            refetch()
          } else {
            message.error(res.data.message || '删除失败');
          }
        } catch {
          message.error('删除请求失败');
        }
      },
    });
  };

  const onStatusChange = async (value: boolean, record: ArtworkAifilterStyleDTO) => {
    console.log(value, "onStatusChange", record)
    const status = Number(value);

    const params = {
      ...record,
      status
    }

    const res = await updateArtworkAiFilterStyle(params);
    if (res.status === 200) {
      refetch()
    }

  }

  const columns: ColumnsType<ArtworkAifilterStyleDTO> = [
    { title: '序号', render: (value, record, index: number) => (page - 1) * pageSize + index + 1 },
    {
      title: '风格预览',
      dataIndex: 'styleImage',
      key: 'styleImage',
      width: 100,
      render: (url) => (url ? <Image width={50} src={url} alt="预览" /> : '-'),
    },
    { title: '标签名称', dataIndex: 'styleType', key: 'styleType' },
    {
      title: '标签排序',
      dataIndex: 'styleTypeSort',
      key: 'styleTypeSort',
      width: 120,
    },
    { title: '风格名称', dataIndex: 'styleName', key: 'styleName' },
    {
      title: '风格排序',
      dataIndex: 'styleOrder',
      key: 'styleOrder',
      width: 120,
    },
    {
      title: '是否上架',
      dataIndex: 'status',
      key: 'status',
      width: 100,
      render: (v, record) => <Switch value={v} onChange={(value) => onStatusChange(value, record)} />,
    },
    {
      title: '操作时间',
      dataIndex: 'updateTime',
      key: 'updateTime',
      width: 160,
      render: (val) => (val ? dayjs(val).format('YYYY-MM-DD HH:mm') : '-'),
    },
    {
      title: '操作',
      key: 'action',
      fixed: 'right',
      width: 120,
      render: (_, record) => (
        <Space>
          <a onClick={() => onEdit(record)}>编辑</a>
          <a onClick={() => onDelete(record.styleId)}>删除</a>
        </Space>
      ),
    },
  ];

  return (
    <div>
      <Form layout="inline" form={form}>
        <Form.Item name="styleType" label="标签">
          <Select
            allowClear
            style={{ width: 180 }}
            placeholder="请选择"
          >
            {styleTypeOptions.map((type) => (
              <Option value={type.styleType} key={type.styleType}>
                {type.styleType}
              </Option>
            ))}
          </Select>
        </Form.Item>
        <Form.Item name="styleName" label="风格名称">
          <Input
            placeholder="请输入"
            style={{ width: 180 }}
            allowClear
          />
        </Form.Item>
        <Form.Item>
          <Button type="primary" onClick={onSearch}>
            搜索
          </Button>
        </Form.Item>
        <Form.Item>
          <Button
            type="default"
            onClick={onReset}
          >
            重置
          </Button>
        </Form.Item>
      </Form>

      <Space style={{ marginTop: 20 }}>
        <Button
          type="default"
          onClick={() => navigate(`${PageLink.Convert}/create`)}
        >
          创建
        </Button>
      </Space>
      <Table
        rowKey="styleId"
        columns={columns}
        dataSource={data?.records || []}
        loading={loading}
        pagination={{
          current: page,
          pageSize,
          total: data?.total,
          onChange: (page) => run(page),
          showSizeChanger: false,
        }}
        style={{ marginTop: 20 }}
        scroll={{ x: 'max-content' }}
      />
    </div>
  );
};

export default ConvertList;
